module.exports = __webpack_public_path__ + "img/keyboard_1.4478e9f7.png";